import React, { useEffect } from "react";
import MaterialTable from 'material-table';

// reactstrap components
import { Row, Col, Card, CardBody } from "reactstrap";

// style
import { table_translate, table_style } from "constants/MaterialTable.js";

// services
import { showMessage } from "services/message.js";
import { api_GET } from "services/api_service.js";

// Views
import AgendamentoVistoria from "views/Shared/Transportador/AgendamentoVistoria";
import CalendarioVistoria from "views/Shared/Transportador/CalendarioVistoria";
import { useAuth } from "context/auth";

export default function AgendamentoVistoriaLista() {
    const {setLoading} = useAuth();

    const [list_table, set_list_table] = React.useState([]);

    const [showCalendario, set_showCalendario] = React.useState(false);
    const [rowEdit, set_rowEdit] = React.useState(null);
    const handleEdit = (rowData) => {
        set_rowEdit(rowData);
    }

    const loadList = () => {
        setLoading(true);
        api_GET('AgendamentoVistoria')
            .then(result => set_list_table(result.data))
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    const handleReturn = () => {
        set_rowEdit(null);
    }

    useEffect(() => {
        loadList();
    }, []);

    return (
        <>
            <div className={(rowEdit || showCalendario) ? "d-none" : "content"}>
                <Row>
                    <Col md="12">
                        <button type="button" className="btn btn-secundary" onClick={() => set_showCalendario(true)}><i className="fa fa-calendar-alt"></i>  Visualizar Agenda</button>
                        <MaterialTable style={{ minHeight: "auto" }}
                            title=""
                            columns={[
                                { title: 'CPF / CNPJ', field: 'cpf_Cnpj' },
                                { title: 'Nome / Fantasia', field: 'nome_Fantasia' },
                                { title: 'Categoria', field: 'categoria_Descricao' },
                                { title: 'Tipo Requerimento', field: 'tipoRequerimento' }
                            ]}
                            data={list_table}
                            isLoading={false}
                            actions={[
                                {
                                    icon: 'edit',
                                    tooltip: 'Editar Registro',
                                    onClick: (event, rowData) => handleEdit(rowData)
                                }
                            ]}
                            localization={table_translate}
                            options={table_style}
                        />
                    </Col>
                </Row>
            </div>
            {rowEdit &&
                <AgendamentoVistoria requerimentoAgendamento={rowEdit} handleReturn={handleReturn}></AgendamentoVistoria>
            }
            {showCalendario &&
                <CalendarioVistoria handleReturn={() => set_showCalendario(false)}></CalendarioVistoria>
            }
        </>
    );
}